<ca-modal-container
    [modalTitle]="'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_DIALOG.TITLE' | translate"
    (dismiss)="close()"
    data-uit="extend-trial-dialog"
>
    <div *ngIf="isAcademiaTrial; else biotech" class="pb-5">
        <div [innerHtml]="'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_DIALOG.DESC_ACADEMY' | translate"></div>
        <ca-files-upload-button
            [buttonText]="'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_DIALOG.UPLOAD_INFO' | translate"
            [pathToAppend]="pathToAppend"
            [supportedImageTypes]="SUPPORTED_FILE_TYPES"
            [blobType]="blobType.UserVerificationDocument"
            [accept]="'image/*,.pdf'"
            [errorNotificationMode]="'notification'"
        ></ca-files-upload-button>
    </div>
    <ng-template #biotech>
        <div class="pb-5">
            <div [innerHtml]="'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_DIALOG.DESC_BIOTECH' | translate"></div>
        </div>
    </ng-template>

    <div class="modal-buttons">
        <button type="button" class="btn btn-secondary w-50" (click)="close()">
            {{ 'GENERAL.MAYBE_LATER' | translate }}
        </button>
        <button
            type="button"
            class="btn btn-primary w-50"
            [disabled]="!isBiotechUser && uploadComponent?.fileUrls.length === 0"
            (click)="submit()"
            data-uit="extend-trial-button"
        >
            {{ 'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.REQUEST_EXTENSION' | translate }}
        </button>
    </div>
</ca-modal-container>
